import { apiHelper, endpoints } from './api';

export const authService = {
  // Login user
  login: async (credentials) => {
    try {
      const response = await apiHelper.post(endpoints.auth.login, credentials);
      return {
        success: true,
        data: response.data,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Login failed'
      };
    }
  },

  // Register new user
  register: async (userData) => {
    try {
      const response = await apiHelper.post(endpoints.auth.register, userData);
      return {
        success: true,
        data: response.data,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Registration failed'
      };
    }
  },

  // Logout user
  logout: async () => {
    try {
      await apiHelper.post(endpoints.auth.logout);
      return {
        success: true,
        message: 'Logged out successfully'
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Logout failed'
      };
    }
  },

  // Verify token validity by checking current user
  verifyToken: async (token) => {
    try {
      const response = await apiHelper.get(endpoints.auth.me);
      return response.success;
    } catch (error) {
      return false;
    }
  },

  // Get user profile
  getProfile: async () => {
    try {
      const response = await apiHelper.get(endpoints.auth.me);
      return {
        success: true,
        data: response.data,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Failed to get profile'
      };
    }
  },

  // Update user profile
  updateProfile: async (userData) => {
    try {
      const response = await apiHelper.put(endpoints.auth.profile, userData);
      return {
        success: true,
        data: response.data,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Profile update failed'
      };
    }
  },

  // Change password
  changePassword: async (passwordData) => {
    try {
      const response = await apiHelper.post(endpoints.auth.changePassword, passwordData);
      return {
        success: true,
        message: response.message
      };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Password change failed'
      };
    }
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    const token = localStorage.getItem('pizzainn_token');
    const user = localStorage.getItem('pizzainn_user');
    return !!(token && user);
  },

  // Get current user from localStorage
  getCurrentUser: () => {
    try {
      const user = localStorage.getItem('pizzainn_user');
      return user ? JSON.parse(user) : null;
    } catch (error) {
      console.error('Error parsing user data:', error);
      return null;
    }
  },

  // Get current token
  getToken: () => {
    return localStorage.getItem('pizzainn_token');
  },

  // Clear authentication data
  clearAuth: () => {
    localStorage.removeItem('pizzainn_token');
    localStorage.removeItem('pizzainn_user');
  }
};

export default authService;
